module.exports = __webpack_public_path__ + "img/2025big8.f878b1f4.jpg";